import { Route, Routes } from 'react-router';

import { NavigationLayout } from '@/layouts/Navigation';
import { NotFoundPage } from '@/pages/404';
import { AboutPage } from '@/pages/about';
import { HomePage } from '@/pages/home';
import { CookiesPage } from '@/pages/legal/Cookies';
import { LegalPage } from '@/pages/legal/Legal';
import { PrivacyPage } from '@/pages/legal/Privacy';
import { TermsPage } from '@/pages/legal/Terms';
import { PictogramsPage } from '@/pages/pictograms';
import { PictogramPage } from '@/pages/pictograms/id';
import { ReviewsPage } from '@/pages/reviews';
import { ReviewPage } from '@/pages/reviews/id';
import { HowToReviewsPage } from './pages/reviews/howTo';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<NavigationLayout />}>
        <Route index element={<HomePage />} />
        <Route path='pictograms' element={<PictogramsPage />} />
        <Route path='pictograms/:id' element={<PictogramPage />} />
        <Route path='reviews' element={<ReviewsPage />} />
        <Route path='reviews/:id' element={<ReviewPage />} />
        <Route path='how-to-reviews' element={<HowToReviewsPage />} />
        <Route path='how-to-reviews/:id' element={<ReviewPage />} />
        <Route path='about' element={<AboutPage />} />

        <Route path='cookies-policy' element={<CookiesPage />} />
        <Route path='privacy-policy' element={<PrivacyPage />} />
        <Route path='legal' element={<LegalPage />} />
        <Route path='terms-and-conditions' element={<TermsPage />} />

        <Route path='*' element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
